import React from 'react';
import r1 from '../assets/readmore/image1.png';
import r2 from '../assets/readmore/image2.png';
import r3 from '../assets/readmore/image3.png';
import r4 from '../assets/readmore/image4.png';

const ReadmoreHome = () => {
    const data = [
        {
            image: r1,
            text: 'How Might A Mobile App Help Your Non- Profit Company?'
        },
        {
            image: r2,
            text: 'The importance of mobile apps for educational institutions'
        },
        {
            image: r3,
            text: 'The Ultimate Tutorial: Developing Your Own Educational App in 2023'
        },
        {
            image: r4,
            text: 'Trends in UI/UX Design for 2023'
        }
    ];

    return (
        <div className="w-full px-4 sm:px-8 md:px-16 py-10 flex flex-col gap-10 items-center">
            <p className="text-[24px] sm:text-[28px] md:text-[32px] font-semibold leading-[36px] md:leading-[42px] text-center">
                Esparse Matrix Solutions News & Events
            </p>

            <div className="w-full flex flex-wrap justify-center gap-6">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="w-full sm:w-[300px] md:w-[270px] lg:w-[247px] h-auto rounded-lg shadow-[0px_0px_3px_0px_#3C485826] flex flex-col"
                    >
                        <img
                            src={item.image}
                            alt={`event-${index}`}
                            className="object-cover rounded-t-lg h-[180px] w-full"
                        />
                        <div className="p-6 flex flex-col gap-3">
                            <p className="text-[16px] leading-[24px] text-center">
                                {item.text}
                            </p>
                            <button className="w-full font-medium py-2 px-3 rounded border-2 border-[#000]">
                                Read more...
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReadmoreHome;
